<template>
  <div>
    <h1>Wystąpił błąd przy dodawaniu promocji</h1>
    <p v-for="promotionError in promotionErrors" :key="promotionError" class="error">
      {{ promotionError }}
    </p>
  </div>
</template>

<script>
export default {
  name: "PromotionErrorModal",
  computed: {
    promotionErrors() {
      return this.$store.getters.promotionErrors;
    }
  }
};
</script>
<style lang="scss" scoped>
p.error {
  text-align: center;
}
</style>
